/** Page width minus the 0.6in left and right @page margins in print.css. */
export function printContentWidthInches(print) {
    const page = print.pageSize === 'A4' ? { portrait: 8.27, landscape: 11.69 } : { portrait: 8.5, landscape: 11 };
    return (print.orientation === 'landscape' ? page.landscape : page.portrait) - 1.2;
}
//# sourceMappingURL=print-geometry.js.map